import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        vacancies: {
            start_searching_title: 'Start Searching',
            start_searching_message: 'We have a range of great opportunities across every region of the UK.',
            no_results_title: 'No Results',
            no_results_message: 'We were unable to find your perfect job.',
            job_roles: 'Job Role',
            practice_types: 'Practice Types',
            contract_types: 'Hours',
            location: 'Location',
            location_radius: 'Location Radius',
            no_location: 'Unable to find your location.',
            salary_ranges: 'Salary',
            reset: 'Reset',
            search: 'Search',
            view_more: 'View More',
            apply_now: 'Apply Now',
            result: 'result',
            results: 'results'
        }
    },
    fr: {
        vacancies: {
            start_searching_title: 'Lancer la recherche',
            start_searching_message: 'Utilisez les filtres ci-dessus pour rechercher tous nos postes vacants vétérinaires.',
            no_results_title: 'Aucun résultat',
            no_results_message: 'Nous n\'avons pas pu trouver votre emploi idéal.',
            job_roles: 'Métier',
            practice_types: 'Types de pratique',
            contract_types: 'Heures',
            location: 'Ville/Département',
            location_radius: 'Rayon de recherche',
            no_location: 'Impossible de trouver votre emplacement.',
            salary_ranges: 'Salaire',
            reset: 'Réinitialiser',
            search: 'Rechercher',
            view_more: 'En savoir plus',
            apply_now: 'Postuler',
            result: 'Résultat',
            results: 'Résultats'
        }
    },
    it: {
        vacancies: {
            start_searching_title: 'Inizia la ricerca',
            start_searching_message: 'Usa i filtri qui sopra per visualizzare le posizioni aperte!',
            no_results_title: 'Nessun risultato trovato',
            no_results_message: 'Non abbiamo trovato nessun risultato in linea con la tua ricerca.',
            job_roles: 'Posizione lavorativa',
            practice_types: 'Tipologia Struttura',
            contract_types: 'Orari d’apertura',
            location: 'Città/Regione',
            location_radius: 'Area di ricerca',
            no_location: 'Non siamo stati in grado di individuare la posizione da te ricercata.',
            salary_ranges: 'Retribuzione',
            reset: 'Reset',
            search: 'Cerca',
            view_more: 'Scopri di più',
            apply_now: 'Candidati',
            result: 'risultato',
            results: 'risultati'
        }
    },
    de: {
        vacancies: {
            start_searching_title: 'Fang an zu suchen',
            start_searching_message: 'Verwenden Sie die obigen Filter, um offene Stellen anzuzeigen!',
            no_results_title: 'Keine Ergebnisse',
            no_results_message: 'Wir haben keine Ergebnisse gefunden, die Ihrer Suche entsprechen.',
            job_roles: 'Stellenbeschreibung',
            practice_types: 'Übungstypen',
            contract_types: 'Arbeitszeit',
            location: 'Stelle',
            location_radius: 'Standortradius',
            no_location: 'Ihr Standort kann nicht gefunden werden.',
            salary_ranges: 'Gehalt',
            reset: 'Zurücksetzen',
            search: 'Suchen',
            view_more: 'Mehr sehen',
            apply_now: 'Jetzt bewerben',
            result: 'ergebnis',
            results: 'ergebnisse'
        }
    },
    es: {
      vacancies: {
        start_searching_title: 'Comenzar búsqueda',
        start_searching_message: 'Tenemos grandes oportunidades para ti en toda España.',
        no_results_title: 'Sin resultados',
        no_results_message: 'No encontramos tu posición ideal.',
        job_roles: 'Posición',
        practice_types: 'Tipo de centro',
        contract_types: 'Horas',
        location: 'Localización',
        location_radius: 'Radio de localización',
        no_location: 'No hemos podido encontrar tu ubicación.',
        salary_ranges: 'Salario',
        reset: 'Borrar',
        search: 'Buscar',
        view_more: 'Saber más',
        apply_now: 'Envía tu CV',
        result: 'resultado',
        results: 'resultados'
      }
    },
    nl: {
      vacancies: {
        start_searching_title: 'Zoeken',
        start_searching_message: 'We hebben verschillende functies beschikbaar op meerdere locaties in Nederland',
        no_results_title: 'Geen resultaten',
        no_results_message: 'We hebben jouw perfecte baan nog niet gevonden...',
        job_roles: 'Functie',
        practice_types: 'Praktijk type',
        contract_types: 'Uren',
        location: 'Plaats',
        location_radius: 'Afstand',
        no_location: 'Locatie niet gevonden',
        salary_ranges: 'Salaris',
        reset: 'Reset',
        search: 'Zoeken',
        view_more: 'Bekijk',
        apply_now: 'Solliciteer direct',
        result: 'resultaat',
        results: 'resultaten'
      }
    },
    pt: {
      vacancies: {
        start_searching_title: 'Comece a pesquisar',
        start_searching_message: 'Temos um conjunto de excelentes oportunidades em Portugal.',
        no_results_title: 'Sem Resultados',
        no_results_message: 'Não conseguimos encontrar a vaga que pretende.',
        job_roles: 'Função',
        practice_types: 'Área Laboral',
        contract_types: 'Horas',
        location: 'Localização',
        location_radius: 'Distância',
        no_location: 'Não foi possível encontrar a sua localização.',
        salary_ranges: 'Salário',
        reset: 'Reiniciar',
        search: 'Procurar',
        view_more: 'Ver mais',
        apply_now: 'Submeter agora',
        result: 'resultado',
        results: 'resultados'
      }
    }
}; 

var defaultLanguage = 'en';

switch( document.documentElement.lang ) {
    case "en-gb":
        defaultLanguage = 'en';
      break;
    case "en-US":
        defaultLanguage = 'en';
      break;
    case "fr-FR":
        defaultLanguage = 'fr';
      break;
    case "it-IT":
        defaultLanguage = 'it';
        break;
    case "de-DE":
        defaultLanguage = 'de';
        break;
    case "es-ES":
        defaultLanguage = 'es';
        break;
    case "nl-NL":
        defaultLanguage = 'nl';
        break;
    case "pt-pt":
        defaultLanguage = 'pt';
        break;
    default:
        defaultLanguage = 'en';
        break;
}

export default createI18n({
    locale: defaultLanguage,
    messages
});
